export default __webpack_public_path__ + "static/BAP_6332_rgb_fine-457ce03cd9ba2586c8908f40fee9d0d3.jpg";